// CLASSES
import AppConfig from "@classes/AppConfig";
import Validator from "@classes/Validator";

export default function (props, state) {
	if (AppConfig.get("developmentOptions").ignoreFullfillment === true)
	{
		return true;
	}

	const {fields} = state;

	if (fields.proxy_holder_name.length <= 0)
	{
		return false;
	}

	if (fields.proxy_holder_identity.length <= 0 ||
		(!Validator.validateOrgNum(fields.proxy_holder_identity, true) &&
			!Validator.validateSsn(fields.proxy_holder_identity, false)))
	{
		return false;
	}

	if (fields.requireAddress)
	{
		if (fields.proxy_holder_street.length <= 0 ||
			fields.proxy_holder_zip.length <= 0 ||
			fields.proxy_holder_city.length <= 0)
		{
			return false;
		}
	}

	if (fields.proxy_holder_email.length <= 0 ||
		!Validator.validateEmail(fields.proxy_holder_email))
	{
		return false;
	}

	return true;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Fullmakt/Fullmaktstagare.fulfillment.js